<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>
import { Decrypt, Encrypt } from "./lib/encryption";

export default {
  name: "App",
  data() {
    return {
      encryptsecret: "kasjffssvgsfjjsafs",
    };
  },
  components: {},
  beforeCreate() {
    if (!JSON.pars(Decrypt(localStorage.dark))) {
      localStorage.isdark = Encrypt(JSON.stringify(true));
    }
    let dark = JSON.pars(Decrypt(localStorage.dark));
    this.$vuetify.theme.dark = dark;

    this.$vuetify.theme.dark = JSON.parse(Decrypt(localStorage.isdark));

  },
};
</script>
